import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenAddedToCartDialogComponent } from "./added-to-cart-dialog.component";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { IconModule, ItemCounterModule, KeyboardFocusModule, PromotionsModule, SpinnerModule } from "@spartacus/storefront";
import { I18nModule, UrlModule } from "@spartacus/core";
import { GenAddedToCartDialogEventListener } from "./added-to-cart-dialog-event.listener";
import { GenCartSharedModule } from '../cart-shared/cart-shared.module';
import { GenNoReturnWarningComponent } from '../../product/no-return-warning/no-return-warning.component';
import { GenProductGridItemComponent } from '../../product/product-list/product-grid-item/product-grid-item.component';
import { GenCarouselComponent } from 'src/app/generac/shared/components/carousel/carousel.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    SpinnerModule,
    PromotionsModule,
    UrlModule,
    IconModule,
    I18nModule,
    ItemCounterModule,
    KeyboardFocusModule,
    GenNoReturnWarningComponent,
    GenCarouselComponent,
    GenProductGridItemComponent,
    GenCartSharedModule,
  ],
  declarations: [GenAddedToCartDialogComponent],
  exports: [GenAddedToCartDialogComponent],
})
export class GenAddedToCartDialogModule {
  constructor(_addToCartDialogEventListener: GenAddedToCartDialogEventListener) {
    // Intentional empty constructor
  }
}
